const getItemsEan = (commands, companyId) => {
  const itemsEan = [];
  commands.map(command =>
    command.items.map(item =>
      itemsEan.push({
        companyId,
        reference: item.externalReference
      })
    )
  );
  return {
    products: itemsEan
  };
};

export default getItemsEan;
